import React from 'react';
import { Route, Routes, HashRouter } from 'react-router-dom';
import { EmailFormMode } from 'enums/emailFormModes';
import EditTimeout from 'components/edit/EditTimeout';
import Subscribe from '../subscribe/Subscribe';
import SubscribeConfirmation from '../subscribe/SubscribeConfirmation';
import EmailForm from '../emailForm/EmailForm';
import Edit from '../edit/Edit';
import Unsubscribe from '../unsubscribe/Unsubscribe';
import UnsubscribeConfirmation from '../unsubscribe/UnsubscribeConfirmation';

const EMAIL_FORM_MODE_EDIT: EmailFormMode = EmailFormMode.EditMode;
const EMAIL_FORM_MODE_UNSUBSCRIBE: EmailFormMode = EmailFormMode.UnsubscribeMode;

const ManageRoutes = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/subscribe" element={<Subscribe />} />

        <Route path="/subscribe/:id" element={<Subscribe />} />
        <Route
          path="/subscribe/successful"
          element={<SubscribeConfirmation isSuccessful />}
        />
        <Route
          path="/subscribe/failed"
          element={<SubscribeConfirmation isSuccessful={false} />}
        />
        <Route
          path="/subscribe/timeout"
          element={<SubscribeConfirmation isSuccessful={false} isTimeout />}
        />

        <Route
          path="/request-editing"
          element={<EmailForm mode={EMAIL_FORM_MODE_EDIT} />}
        />

        <Route path="/edit" element={<Edit />} />

        <Route path="/edit/timeout" element={<EditTimeout />} />

        <Route
          path="/request-unsubscription/:id"
          element={<EmailForm mode={EMAIL_FORM_MODE_UNSUBSCRIBE} />}
        />

        <Route
          path="/unsubscribe/successful"
          element={<UnsubscribeConfirmation viaNewsletter={false} isSuccessful />}
        />

        <Route
          path="/unsubscribe/failed"
          element={<UnsubscribeConfirmation viaNewsletter={false} isSuccessful={false} />}
        />

        <Route
          path="/unsubscribe/timeout"
          element={
            <UnsubscribeConfirmation
              viaNewsletter={false}
              isSuccessful={false}
              isTimeout
            />
          }
        />

        <Route path="/confirm-unsubscription/:id" element={<Unsubscribe />} />
      </Routes>
    </HashRouter>
  );
};

export default ManageRoutes;
